var en_us = {
    values: {
        "Input Port": "Input Port",
        "MQTT identifier": "MQTT identifier",
        "Event type": "Event type to output data",
        "Broker address": "Broker address",
        "Publish topic": "Publish topic",
        "Publish Quality of Service (QoS)": "Publish Quality of Service (QoS)",
        "User (optional)": "User (optional)",
        "Password (optional)": "Password (optional)",
        "SSL Configuration": "SSL Configuration",
        "SSLConfiguration Help": "The following configuration is OPTIONAL. It is only required if using an SSL connection to connect to the MQTT broker",
        "KeyStore Type": "KeyStore Type",
        "KeyStore Path": "KeyStore Path",
        "KeyStore Password": "KeyStore Password",
        "Key Alias": "Key Alias",
        "Key Password": "Key Password",
        "Trusted Store Path": "Trusted Certificates KeyStore Path",
        "Trusted Store Password": "Trusted Certificates KeyStore Password",
        "Enable Hostname Verification": "Enable Hostname Verification",
        "Server Hostname Verification Info": "This will verify if the received server certificate contains the same hostname as the server.",
        "Unit management": "Unit management",
        "Cancel": "Cancel",
        "UOM list error. Check details": "UOM list error. Check details",
        Topic_Management: "Topics to subscribe",
        Topic_Error: "Topic list error. Check details",
        Empty_Topic: ({ line }) =>
            `Topic cannot be empty in line ${line}`,
        Topic_Exists: ({ topic, line }) =>
            `Topic ${topic} at line ${line} already exists`,
        Invalid_QoS: ({ topic, line }) =>
            `Topic ${topic} at line ${line} has an invalid QoS: QoS should be 0, 1 or 2.`,
        Empty_EventType: ({ topic, line }) =>
            `Topic ${topic} at line ${line} has an invalid Event Type: Event type should not be empty.`,
        Wrong_Schema: ({ valueType }) => 
            `Wrong schema type. Expected number as QoS but found ${valueType}`,
        Unable_Parse: ({ valueType }) => 
            `Unable to parse JSON. Expected a JSON Object in topicsToQoS but found ${valueType}`
    }
};

module.exports = en_us;
